<ng-container *ngIf="upcomingData">
  <div class="TableTitle">
    <h2 class="Report">Report</h2>
    <h1>Recent and upcoming spectrum awards</h1>
  </div>
  <table class="table ResponsiveTable ResponsiveTable--withHeaderMobile" *ngIf="upcomingData.length > 0" datatable [dtOptions]="dtOptions">
    <thead class="AnimatedThead">
      <tr>
        <th scope="col">Country</th>
        <th scope="col">Award</th>
        <th scope="col">Title</th>
        <th scope="col">Status</th>
        <th scope="col">MHz offered</th>
        <th scope="col">Bands</th>
        <th scope="col">Cullen report</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of upcomingData">
        <td data-th="Country" class="NoWrap">
          <a [routerLink]="'/awards/country/'+row.countryCode" [queryParams]="{regionCode: regionCodes}">{{ ('CountryNames.' + row.countryCode) | translate }}</a>
        </td>
        <td data-th="Award" [class.EmptyCell]="!row.awardKey">
          <a [routerLink]="'/awards/'+row.awardKey" [queryParams]="{regionCode: regionCodes}">{{ row.awardKey | delete2FirstChar }}</a>
        </td>
        <td data-th="Title" [class.EmptyCell]="!row.shortTitle">
          {{ row.shortTitle }}
        </td>
        <td data-th="Status" [class.EmptyCell]="!row.status">
          {{ row.status }}
        </td>
        <td data-th="MHz offred" [class.EmptyCell]="!row.mhzOffered" [class.HideCellOnMobile]="displayService.hideCellOnMobile(row.mhzOffered)" [attr.data-order]="row.mhzOffered">
          {{ row.mhzOffered }}
        </td>
        <td data-th="Bands" [class.EmptyCell]="!row.bandNames">
          {{ row.bandNames }}
        </td>
        <td data-th="Cullen report" class="NoWrap" [class.EmptyCell]="row.reports.length===0">
          <div *ngFor="let report of row.reports" class="Loop">
            <a [href]="getDocumentUrl(report.uniqueNumber)" target="fromSpectrum" *ngIf="report.displayName">
              {{ report.displayName | capitalize }}
            </a>
            <a [href]="getDocumentUrl(report.uniqueNumber)" target="fromSpectrum" *ngIf="!report.displayName">
              {{ displayService.displayReportNames(report.uniqueNumber) }}
            </a>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
  <div class="NoResult" *ngIf="upcomingData.length===0">
    <p>No award</p>
  </div>
</ng-container>